import { leagueFetch } from '@leagueplatform/league-fetch';
import { MasonryNodeResponse } from '../types/get-masonry-node';
import { getMasonryRequestHeaders } from './get-masonry-request-headers';
// Un-comment this if using mock data
// import { mockMasonryRootNodeV2 } from '../__mocks__/get-masonry-node-mocks-v2';

export type GetMasonryNodeOptions = {
  path: string;
  method: Request['method'];
};

export const getMasonryNode = async ({
  path,
  method,
}: GetMasonryNodeOptions): Promise<MasonryNodeResponse | undefined> => {
  // Set argument to true if using mock data
  const headers = getMasonryRequestHeaders();

  const response = await leagueFetch(path, {
    method,
    allowUnauthenticated: true,
    headers,
  });

  if (!response.ok) {
    // Handle error responses
    throw new Error(`getMasonryNode error: ${response.status}`);
  }

  if (response.status === 204) {
    return undefined;
  }

  try {
    const responseJson: MasonryNodeResponse = await response.json();

    return responseJson;
  } catch (err) {
    // Handle cases where response is not valid JSON
    throw new Error(
      `Failed to parse response JSON: ${
        err instanceof Error ? err.message : ''
      }`,
    );
  }
};
